module.exports = __webpack_public_path__ + "img/company.1b6fdc25.png";